function Cart() {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5249 11.1111H7.34625L7.57351 12.2222H16.8936C17.4283 12.2222 17.8247 12.7188 17.7062 13.2402L17.5146 14.0832C18.1636 14.3982 18.6111 15.0635 18.6111 15.8333C18.6111 16.9167 17.725 17.7932 16.6381 17.7776C15.6025 17.7627 14.7509 16.9223 14.723 15.8871C14.7077 15.3215 14.9342 14.809 15.3064 14.4444H8.02695C8.38726 14.7974 8.61111 15.2891 8.61111 15.8333C8.61111 16.938 7.69 17.8275 6.57396 17.7756C5.58299 17.7296 4.77705 16.9289 4.72497 15.9382C4.68476 15.1732 5.08733 14.4988 5.69896 14.1471L3.25983 2.22222H0.833334C0.37309 2.22222 0 1.84913 0 1.38889V0.833334C0 0.37309 0.37309 0 0.833334 0H4.39337C4.78924 0 5.13045 0.278507 5.20979 0.66632L5.52806 2.22222H19.1663C19.7011 2.22222 20.0974 2.71879 19.9789 3.24024L18.3375 10.4625C18.2513 10.8419 17.914 11.1111 17.5249 11.1111ZM14.1667 5.83333H12.5V4.44445C12.5 4.13761 12.2513 3.88889 11.9444 3.88889H11.3889C11.0821 3.88889 10.8333 4.13761 10.8333 4.44445V5.83333H9.16667C8.85983 5.83333 8.61111 6.08205 8.61111 6.38889V6.94445C8.61111 7.25129 8.85983 7.5 9.16667 7.5H10.8333V8.88889C10.8333 9.19573 11.0821 9.44445 11.3889 9.44445H11.9444C12.2513 9.44445 12.5 9.19573 12.5 8.88889V7.5H14.1667C14.4735 7.5 14.7222 7.25129 14.7222 6.94445V6.38889C14.7222 6.08205 14.4735 5.83333 14.1667 5.83333Z"
        fill="url(#paint0_linear_622_208)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_622_208"
          x1="10"
          y1="0"
          x2="10"
          y2="17.7778"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.505208" stopColor="#B8263D" />
          <stop offset="1" stopColor="#FEB600" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Cart;
